import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type {
  CreatePaymentDto,
  FindAllPaymentsQueryDto,
  Payment,
  UpdatePaymentDto,
} from '@/entities/payments/payment.entity';
import { Service } from './http-service';
import type { RefundUnallocatedPaymentAmountResponseDto } from '@carvia/ros-client-types';

class PaymentsService extends Service<Payment, CreatePaymentDto, UpdatePaymentDto> {
  async getAllWithQuery(params: FindAllPaymentsQueryDto) {
    const res = await this.httpClient.get<PaginatedResponse<Payment>>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }

  async refundUnallocatedPaymentAmount(
    paymentId: string,
    amount: number,
  ): Promise<RefundUnallocatedPaymentAmountResponseDto> {
    const res = await this.httpClient.post<RefundUnallocatedPaymentAmountResponseDto>(
      `${this.endpoint}/${paymentId}/refund-unallocated-payment-amount`,
      { amount },
    );
    return res.data;
  }
}

export const paymentsService = new PaymentsService('/payments');
